import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { pageUrl } from "@/data/site";

export const Breadcrumbs = ({ items }) => {
  return (
    <nav aria-label="breadcrumb" className="text-xs text-gray-500" data-testid="breadcrumbs">
      <ol className="flex items-center flex-wrap gap-1">
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            {item.to ? (
              <Link to={pageUrl(item.to)} className="hover:text-brand-red transition-colors">{item.label}</Link>
            ) : (
              <span className="text-brand-black font-medium">{item.label}</span>
            )}
            {i < items.length - 1 && <ChevronRight className="w-3.5 h-3.5" />}
          </li>
        ))}
      </ol>
    </nav>
  );
};
